import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import React, { Component } from 'react';
import {
    Link, NavLink
} from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import android from '../../images/android.png';
import logo from "../../images/KlickExLogo_w.png";

import ios from '../../images/ios.png';
import services from '../../services/allservices.jsx';
import '../../stylesheet/guestnavbar.css';
import { getClientId, getClientSecret, buildClientHeader } from "../../../src/utils/clientAuth.js";
import uuidv4 from 'uuid/v4';


const styles = {
    activeStyle: {
        backgroundColor: "#fff",
        boxShadow: "0 0px 0px 0px rgba(42, 81, 148, 0.2), 0 16px 16px -11px rgba(42, 81, 148, 0.6)",
        border: "1px solid #f5f5f5",
        borderBottom: "2px solid #333",
    },
    customWidth: {
        width: "100%",
        fontSize: "14px",
        color: "#333"
    },
    floatingLabelStyle: {
        color: "#fff",
        fontSize: "19px",
        fontWeight: "600"
    },
    modalfloatingLabelStyle: {
        color: "#fff",
        fontSize: "14px",
        fontWeight: "600"
    },
    floatingLabelFocusStyle: {
        color: "#333"
    },
    modalfloatingLabelFocusStyle: {
        color: "#333"
    },
    underlineFocusStyle: {
        color: "#fff"
    },
    radioButton: {
        fill: "#333",
    },

    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    SelectDisplayProps: {
        maxHeight: "383px",
        top: "260px"
    },
    headline: {
        fontSize: 24,
        paddingTop: 16,
        marginBottom: 12,
        fontWeight: 400,
    },
    inkBarStyle: {
        background: "#fff"
    },
    tab: {
        background: "#007bff"
    },
    inputStyle: {
        color: "#333"
    },
    modalinputStyle: {
        color: "#333"
    },
    listStyle: {
        color: "#fff"
    },
    selectedMenuItemStyle: {
        color: "#fff"
    },
    buttonStyle: {
        minWidth: "40px",
        height: "0px"
    }
};

class GusetNavbar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            disabled: false
        }
    }
    handleHover = () => {
        document.getElementById("appDownload").style.display = "block"
    }
    handleOut = () => {
        document.getElementById("appDownload").style.display = "none"
    }
    onFieldChange(e, value) {
        this.setState({
            [e.target.name]: value
        })

    }

    handleSendLink = () => {
        let state = {
            emailId: this.state.email
        }
        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
        let gid = getClientId();
        let traceId = getClientId();
        fetch(plink + services.send_api_link, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'clientId': gid,
                'clientSecret': getClientSecret(gid, this.state.emailId),
                'X-Trace-Id': traceId,
                'X-Client-APP': buildClientHeader(),

            }),
            body: JSON.stringify(state)
        })
            .then(
                function (response) {
                    if (response.status === 200 || response.status === 201 || response.status === 204) {
                        toast.success(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                    }
                    else {
                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                    }
                }
            )
    }
    render() {
        return (
            <div style={{ overflow: 'hidden' }} className="signin">
                <div className='container p-0'>

                    <nav className="navbar navbar-expand-sm bg-trans navbar-dark p-0" style={{ backgroundColor: 'transparent' }}>
                        <div className="col-md-12 ml-0">
                            <div className="row ">
                                <div className="col-md-12">
                                    <Link to="/" className="navbar-brand" href="#"><img src={logo} alt='' style={{ width: '70%' }} /></Link>
                                </div>
                                <div style={{ position: 'absolute', right: '20px', top: '8px' }}>
                                    <Link exact to="/contact-us" style={{ color: 'black' }} className="nav-link textwhite">
                                        Contact us
                                    </Link>
                                </div>

                            </div>
                        </div>






                    </nav >

                </div>
            </div>
        );
    }
}

export default GusetNavbar;


// WEBPACK FOOTER //
// ./src/components/navigation/guestnavbar.jsx